import webpack from 'webpack';

export default (env = {}) => (
  new webpack.EnvironmentPlugin({
    NODE_ENV: 'development',
    ...env,
  })
);

